import { Stack } from 'expo-router';
import React, { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { getAnonymousId } from 'services/analytics/segment/segment';
import { updateStatsigUser } from 'services/statsig/statsigManager';
import ScreenAnalytics from 'shared/components/ScreenAnalytics/ScreenAnalytics';
import { SMALL_SCREEN_MAX_WIDTH } from 'shared/constants/layout';
import { useAuth } from 'shared/providers/auth';
import theme from 'shared/styles/theme';
import { logBreadcrumb, logError } from 'shared/utils/sentry/sentry';

function PublicLayoutWeb() {
  const { isLoggedIn } = useAuth();

  // Sync Segment anonymousId with Statsig for unauthenticated users
  useEffect(() => {
    const syncAnonymousIdentity = async () => {
      if (isLoggedIn) {
        return;
      }

      try {
        const anonymousId = await getAnonymousId();
        if (anonymousId) {
          logBreadcrumb({
            level: 'info',
            message: 'Syncing anonymous identity to Statsig (web)',
            data: { anonymousId },
          });
          await updateStatsigUser(anonymousId, anonymousId);
        }
      } catch (_error) {
        logError('Failed to sync anonymous identity to Statsig');
      }
    };

    void syncAnonymousIdentity();
  }, [isLoggedIn]);

  return (
    <View style={styles.container}>
      <ScreenAnalytics />
      <Stack
        screenOptions={{
          contentStyle: {
            backgroundColor: theme.color.background.primary,
          },
          headerShown: false,
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    marginHorizontal: 'auto',
    maxWidth: SMALL_SCREEN_MAX_WIDTH,
    width: '100%',
  },
});

export default PublicLayoutWeb;
